import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import CloseIcon from '@mui/icons-material/Close';
import CBCTViewer from './CBCTViewer';
import STLFullViewer from './STLFullViewer';
import ImageEditor from './ImageEditor';
import ScreenshotViewer from './ScreenshotViewer';

const ViewerPanel = ({
    selectedFile, selectedPair, hasFiles, onClose, onScreenshot, onUpdateFile,
}) => {
    const isImage = !selectedPair && (selectedFile?.isImage || selectedFile?.isScreenshot);
    const viewerHeight = isImage ? 'auto' : (hasFiles ? 'calc(100vh - 310px)' : 'calc(100vh - 160px)');

    return (
        <Box sx={{
            width: isImage ? 'fit-content' : '100%',
            maxWidth: '100%',
            mx: isImage ? 'auto' : 0,
            height: viewerHeight, borderRadius: 1.5,
            overflow: isImage ? 'visible' : 'hidden',
            bgcolor: 'var(--bg-base)', border: '1px solid var(--border)',
            display: 'flex', flexDirection: 'column',
        }}>
            {/* Header */}
            <Box sx={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                px: 2, py: 1, borderBottom: '1px solid var(--border)', flexShrink: 0,
            }}>
                <Typography sx={{ color: 'var(--text-1)', fontSize: 13, fontWeight: 500 }}>
                    {selectedPair ? selectedPair.label : (selectedFile.category || selectedFile.file.name)}
                </Typography>
                <IconButton size="small" onClick={onClose}
                    sx={{ color: 'var(--text-3)', '&:hover': { color: 'var(--text-1)' } }}>
                    <CloseIcon sx={{ fontSize: 18 }} />
                </IconButton>
            </Box>

            {/* Content */}
            <Box sx={{ flex: isImage ? 'none' : 1, display: 'flex', overflow: isImage ? 'visible' : 'hidden' }}>
                {selectedPair ? (
                    <STLFullViewer upper={selectedPair.upper} lower={selectedPair.lower} onScreenshot={onScreenshot} />
                ) : selectedFile.isScreenshot ? (
                    <ScreenshotViewer src={selectedFile.preview} onSave={onScreenshot} />
                ) : selectedFile.isImage ? (
                    <ImageEditor
                        src={selectedFile.preview}
                        fileName={selectedFile.file.name}
                        onUpdate={(newSrc) => onUpdateFile(selectedFile, newSrc)}
                    />
                ) : selectedFile.is3D ? (
                    <STLFullViewer singleFile={selectedFile.file} onScreenshot={onScreenshot} />
                ) : selectedFile.isCBCT ? (
                    <CBCTViewer file={selectedFile.file} onScreenshot={onScreenshot} />
                ) : (
                    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                        <InsertDriveFileIcon sx={{ fontSize: 64, color: '#c9a0dc' }} />
                        <Typography sx={{ color: 'var(--text-2)', fontSize: 13 }}>
                            {selectedFile.file.name}
                        </Typography>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default ViewerPanel;
